<template>
  <div class="container">
  <div class="mt-11 flex w-full">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/4 mx-auto text-center">
      <img src="@/assets/images/document/sign-success.svg" alt="Success" width="465" class="mx-auto mb-4 max-w-full">
      <h1 class="sm:mx-0 mt-5 mb-10 text-5xl d-theme-heading-color">¡Bienvenido al Plan Profesional!</h1>
      <h4 class="sm:mx-0 mx-2 sm:mb-10 font-w-400">
        Se ha guardado con éxito el cambio al <b>"{{ getPlanName }}"</b>
      </h4>
      <p class="text-2xl mb-10">¡Ahora tienes acceso a nuevas ventajas con el Plan Profesional! <b>Disfruta de 15 firmas mensuales</b>, descuentos en adicionales, validación de identidad, funciones avanzadas y soporte preferente.</p>
      <vs-button size="large" to="/">Mis documentos</vs-button>
    </div>
  </div>
</div>
</template>


<script>
export default {
  name: "purchaseSuccess",
  computed: {
    getPlanName() {
      return this.$store.state.account.user.me.plan.name;
    }
  },
  mounted() {
    const email = this.$store.state.account.user.me.email;
    const phone = this.$store.state.account.user.me.phone;
    const value = this.$store.state.account.user.me.plan.price_per_renew;
    const planName = this.$store.state.account.user.me.plan.name;
    const currency = 'MXN';
    const idTransaccion = Math.floor(1000000 + Math.random() * 9000000);
    const discountRate = this.$store.state.account.user.me.plan.discount;

    const isAnnual = value > 400;
    const itemId = isAnnual ? 'plan_anual_firma_electronica' : 'plan_mensual_firma_electronica';

    const discountDecimal = discountRate > 0 ? discountRate / 100 : 0;

    const finalValue = isAnnual && discountDecimal > 0 ? value * (1 - discountDecimal) : value;

    window.gtag('set', 'user_data', {
      "email": email,
      "phone_number": `+${phone}`
    });

    window.gtag('event', 'conversion', {
      'send_to': 'AW-462309740/Xm9KCMTb3dwZEOySudwB',
      'value': finalValue,
      'currency': currency,
      'transaction_id': idTransaccion,
      'user_id': email,
      'phone_number': `+${phone}`,
      'items': [
        {
          'item_id': itemId,
          'item_name': planName,
          "units": "percentage",
          'discount': discountRate,
          'price': finalValue,
          'quantity': 1
        }
      ]
    });
    window.gtag('event', 'purchase', {
      'transaction_id': idTransaccion,
      'affiliation': 'Website',
      'value': finalValue,
      'currency': currency,
      'items': [
        {
          'item_id': itemId,
          'item_name': planName,
          "units": "percentage",
          'discount': discountRate,
          'currency': currency,
          'price': value,
          'quantity': 1
        }
      ],
      'user_id': email,
      'phone_number': `+${phone}`
    });

    window.fbq('track', 'Purchase', {
      value: finalValue,
      currency: currency,
      contents: [{ id: itemId, name: planName, quantity: 1 }],
      content_type: 'product',
      num_items: 1,
      transaction_id: idTransaccion
    });


  },


}

</script>


<style>
.mt-11{
  margin-top: 6.5em!important;
}

</style>
